import InboxChip from './InboxChip.jsx';
import { EVENT_TYPE } from '../../constants/eventTypes.js';
import { INTERIM_EVENT_TYPE } from '../../constants/interimEventTypes.js';
import { ProposalPreview } from '../EventTypes/Proposal/index.js';
import { TaskPreview } from '../EventTypes/Task/index.js';

function renderInterimMeta(event) {
  const parts = [event.refLabel, event.studio].filter(Boolean);
  if (!parts.length) return null;
  return (
    <div className="flex min-w-0 items-center gap-1.5 text-[11px] text-content-faint">
      <span className="min-w-0 truncate">{parts.join(' · ')}</span>
    </div>
  );
}

function renderQuestionMeta(event) {
  const detail = event.detail;
  if (!detail?.askedBy && !event.description) return null;
  return (
    <div className="flex min-w-0 flex-col gap-1">
      {event.description ? (
        <p className="line-clamp-2 text-[11px] leading-snug text-content-faint">{event.description}</p>
      ) : null}
      {detail?.askedBy ? (
        <div className="flex min-w-0 items-center gap-1.5 text-[11px] text-content-faint">
          <span className="min-w-0 truncate">
            {detail.askedBy.name} · {detail.askedBy.role}
          </span>
          {detail.linkedEvent ? <InboxChip shrinkable>{detail.linkedEvent.id}</InboxChip> : null}
        </div>
      ) : null}
    </div>
  );
}

function renderTrainMeMeta(detail) {
  if (!detail) return null;
  return (
    <div className="flex min-w-0 items-center gap-1.5 text-[11px] text-content-faint">
      {detail.submitter ? (
        <span className="min-w-0 truncate">
          {detail.submitter.name} · {detail.submitter.role}
        </span>
      ) : null}
      {detail.sourceRecord ? <InboxChip shrinkable>{detail.sourceRecord}</InboxChip> : null}
      {detail.currentValue && detail.proposedValue ? (
        <span className="shrink-0 font-mono">
          {detail.currentValue} → {detail.proposedValue}
        </span>
      ) : null}
    </div>
  );
}

function renderProposalMeta(event) {
  const kbPart = event.refLabel ?? event.studio;
  return (
    <div className="flex min-w-0 flex-col gap-1">
      {kbPart ? (
        <div className="flex min-w-0 items-center gap-1.5 text-[11px] text-content-faint">
          <span className="min-w-0 truncate">{kbPart}</span>
        </div>
      ) : null}
      <ProposalPreview event={event} />
    </div>
  );
}

function renderTaskMeta(event) {
  return <TaskPreview event={event} />;
}

const META_BY_TYPE = {
  [EVENT_TYPE.QUESTION]: renderQuestionMeta,
  [EVENT_TYPE.TRAIN_ME]: (event) => renderTrainMeMeta(event.detail),
  [INTERIM_EVENT_TYPE.CHANGE_REQUEST]: renderInterimMeta,
  [INTERIM_EVENT_TYPE.PROPOSAL]: renderProposalMeta,
  [INTERIM_EVENT_TYPE.CLAIM_SUGGESTION]: renderInterimMeta,
  [INTERIM_EVENT_TYPE.TASK]: renderTaskMeta,
};

/**
 * Second-row metadata that only some event types carry. Lookup by type so
 * InboxListItem does not grow another branch per story.
 */
function InboxListItemMeta({ event }) {
  const render = META_BY_TYPE[event.type];
  return render?.(event) ?? null;
}

export default InboxListItemMeta;
